import React from "react";
import { RuleExpectedCondition, RuleRelation } from "../../../vars";
import { deepCopy } from "../../../utils";
import SelectV2 from "../../../view/SelectV2";
import * as storeService from "../addRuleStoreService";
import { Minus } from "lucide-react";

function ExpectedConditionDropdown({ script, condition, index, itemsAmount, rule, disabled }) {

    const conditions = [
        { name: 'Contains', value: RuleExpectedCondition.CONTAINS },
        { name: 'Not contains', value: RuleExpectedCondition.NOT_CONTAINS },
        { name: 'Equals', value: RuleExpectedCondition.EQUALS },
        { name: 'Starts with', value: RuleExpectedCondition.STARTS_WITH },
        { name: 'Ends with', value: RuleExpectedCondition.ENDS_WITH },
    ]

    const relations = [
        { name: 'And', value: RuleRelation.AND },
        { name: 'Or', value: RuleRelation.OR },
    ]
    const conditionOptions = conditions.map((option) => ({ value: option.value, label: option.name }));
    const relationOptions = relations.map((option) => ({ value: option.value, label: option.name }));


    const onConditionTypeChange = (conditionType, conditionOrder, scriptOrder) => {

        const ruleCopy = deepCopy(rule);
        // const condition= ruleCopy.conditions.find(el => el.order === order)
        // const index = ruleCopy.conditions.indexOf(ruleCopy.conditions.find(el => el.order === order));

        const scriptIndex = ruleCopy.scripts.indexOf(ruleCopy.scripts.find(el => el.order === scriptOrder));
        const conditionIndex = script.conditions.indexOf(script.conditions.find(el => el.order === conditionOrder));
        ruleCopy.scripts[scriptIndex].conditions[conditionIndex].type = conditionType;
        storeService.changeRule(ruleCopy);
    }

    const onConditionDefinitionChange = (conditionDefinition, conditionOrder, scriptOrder) => {
        const ruleCopy = deepCopy(rule);
        // const index = ruleCopy.conditions.indexOf(ruleCopy.conditions.find(el => el.order === order));

        const scriptIndex = ruleCopy.scripts.indexOf(ruleCopy.scripts.find(el => el.order === scriptOrder));
        const conditionIndex = script.conditions.indexOf(script.conditions.find(el => el.order === conditionOrder));
        ruleCopy.scripts[scriptIndex].conditions[conditionIndex].relation = conditionDefinition;
        storeService.changeRule(ruleCopy);
    }

    // const onRemoveClick_orig = (order) => {
    //     const ruleCopy = deepCopy(rule);
    //     const sortedConditions = ruleCopy.conditions.sort((a, b) => a.order - b.order);
    //     const index = sortedConditions.indexOf(sortedConditions.find(el => el.order === order));
    //     sortedConditions.splice(index, 1);
    //     sortedConditions.forEach(condition => condition.order = sortedConditions.indexOf(condition));
    //     ruleCopy.conditions = sortedConditions;
    //     storeService.changeRule(ruleCopy);
    // }

    const onRemoveClick = (conditionOrder, scriptOrder) => {
        const ruleCopy = deepCopy(rule);
        const scriptIndex = ruleCopy.scripts.indexOf(ruleCopy.scripts.find(el => el.order === scriptOrder));

        const sortedConditions = ruleCopy.scripts[scriptIndex].conditions.sort((a, b) => a.conditionOrder - b.conditionOrder);
        const conditionIndex = sortedConditions.indexOf(sortedConditions.find(el => el.order === conditionOrder));

        // const index = sortedConditions.indexOf(sortedConditions.find(el => el.order === order));
        sortedConditions.splice(conditionIndex, 1);
        sortedConditions.forEach(condition => condition.order = sortedConditions.indexOf(condition));
        ruleCopy.scripts[scriptIndex].conditions = sortedConditions;
        storeService.changeRule(ruleCopy);
    }

    return (
        <div className="addrules-form-group-v2" key={index}>
            <label className="addrules-form-label-v2">Output condition</label>
            <div className="addrules-inline-row-v2">
                {/* Condition relation — only shown for non-first conditions */}
                {index !== 0 &&
                    <SelectV2
                        inputId={`condition-relation-${script.order}-${index}`}
                        className="addrules-form-select-sm-v2"
                        value={condition.relation}
                        onChange={(value) => onConditionDefinitionChange(value, index, script.order)}
                        options={relationOptions}
                        isDisabled={disabled}
                    />
                }

                <SelectV2
                    inputId={`condition-type-${script.order}-${index}`}
                    className="addrules-form-select-sm-v2"
                    value={condition.type}
                    onChange={(value) => onConditionTypeChange(value, index, script.order)}
                    options={conditionOptions}
                    isDisabled={disabled}
                />

                {/* Remove condition — only when multiple conditions */}
                {itemsAmount > 1 &&
                    <button
                        className={`addrules-btn-add-v2 ${disabled ? 'disabled' : ''}`}
                        onClick={disabled ? null : () => onRemoveClick(index, script.order)}
                    >
                        <Minus />
                        Remove
                    </button>
                }
            </div>
        </div>
    )

}

export default ExpectedConditionDropdown;
